// extracted by mini-css-extract-plugin
export var brandingStyles = "branding-module--brandingStyles--sI+NP";
export var logoStyles = "branding-module--logoStyles--LpQwm";
export var logoScramblerStyles = "branding-module--logoScramblerStyles--JFPtj";
export var ampersandStyles = "branding-module--ampersandStyles--aPwyV";
export var glitched = "branding-module--glitched--TShAQ";